import React, { useState, useEffect } from 'react';
// import { ChevronRight, Zap, Globe, Wifi, Video, Shield, Star, Users, Trophy, Clock } from 'lucide-react';
import Section from '../../components/home/gaming/Section';
import FeaturesSection from '../../components/home/gaming/FeaturesSection';
import GamingPackagesSection from '../../components/home/gaming/PackagesSection';
import LeaderboardSection from '../../components/home/gaming/LeaderboardSection';

import Footer from '../../components/footer/index';

const GamingPage = () => {
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  

  // Testimonials
  const testimonials = [
    {
      name: 'ProGamer_ID',
      game: 'Valorant Immortal',
      review: 'Ping stabil 8ms, gak pernah lag lagi saat clutch round. GG!',
      rating: 5,
      avatar: '🎯'
    },
    {
      name: 'StreamerMLBB',
      game: 'Mobile Legends Pro',
      review: 'Streaming sambil main 60fps smooth, viewer gak complain lag',
      rating: 5,
      avatar: '📱'
    },
    {
      name: 'EsportsTeam_ACE',
      game: 'CS2 Professional',
      review: 'Team pakai semua, konsisten di turnamen. Recommended!',
      rating: 5,
      avatar: '🏆'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    
    <div className="min-h-screen bg-gray-900 text-white overflow-hidden">
       
      <div className="fixed inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-purple-900/20 to-blue-900/20"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(120,119,198,0.1),transparent_50%)]"></div>
        {/* Animated particles */}
        
        <div className="absolute inset-0">
         
          {[...Array(50)].map((_, i) => (
            <div
              key={i}
              className="absolute w-1 h-1 bg-cyan-400 rounded-full animate-pulse"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 4}s`,
                animationDuration: `${2 + Math.random() * 3}s`
              }}
            ></div>
          ))}
        </div>
      </div>
         
      <div className="relative z-10">
        {/* Hero Section */}
        <Section />

        {/* Features Section */}
        <FeaturesSection />

        {/* Gaming Packages */}
        <GamingPackagesSection />
        
        {/* Leaderboard */}
        <LeaderboardSection />

        <Footer />
      </div>
    </div>
  );
};

export default GamingPage;